import {eTipoPermissao} from '@/enums/ePermissoes';
export default [
 {
  description: 'Titulação',
  path: '/pessoal/pestitulacao',
  name: 'pestitulacao',
  component: () => import('@/views/pessoal/pestitulacao/Index.vue'),
  meta: {
   permissions: [eTipoPermissao.TITULACAONOVO_MENU_1400800399],
  },
  goesToMenu: true,
 },
 {
  description: 'Cadastro de Titulação',
  path: '/pessoal/pestitulacao/cadastro/:id?',
  parent: 'pestitulacao',
  name: 'pestitulacao_create',
  component: () => import('@/views/pessoal/pestitulacao/InclusaoEdicao.vue'),
  meta: {
   permissions: [eTipoPermissao.TITULACAONOVO_MENU_1400800399],
  },
  goesToMenu: true,
 },
]
